import { useCache, CACHE_KEY } from '@/hooks/web/useCache'
import { decrypt, encrypt } from '@/utils/jsencrypt'

const { wsCache } = useCache()

// 获取token
export const getAccessToken = () => {
  // 此处与TokenKey相同，此写法解决初始化时Cookies中不存在TokenKey报错
  return wsCache.get(CACHE_KEY.USER) ? wsCache.get(CACHE_KEY.USER) : wsCache.get('user')
}

export const getUdbAuthCode = () => {
  // 解决初始化时Cookies中不存在Key报错
  return wsCache.get(CACHE_KEY.UDB_AUTH_CODE) ? wsCache.get(CACHE_KEY.UDB_AUTH_CODE) : wsCache.get('udbAuthCode')
}

export const setUdbAuthCode = (udbAuthCode: string) => {
  wsCache.set(CACHE_KEY.UDB_AUTH_CODE, udbAuthCode)
}

export const removeUdbAuthCode = () => {
  wsCache.delete(CACHE_KEY.UDB_AUTH_CODE)
}

// ========== 账号相关 ==========

export type LoginFormType = {
  loginName: string
  password: string
  captcha: string
  rememberMe: boolean
}

export const getLoginForm = () => {
  const loginForm: LoginFormType = wsCache.get(CACHE_KEY.LOGIN_FORM)
  if (loginForm) {
    loginForm.password = decrypt(loginForm.password) as string
  }
  return loginForm
}

export const setLoginForm = (loginForm: LoginFormType) => {
  console.log('setLoginForm:', loginForm)
  loginForm.password = encrypt(loginForm.password) as string
  wsCache.set(CACHE_KEY.LOGIN_FORM, loginForm, { exp: 30 * 24 * 60 * 60 })
}

export const removeLoginForm = () => {
  wsCache.delete(CACHE_KEY.LOGIN_FORM)
}

export const getPoolNo = () => {
  // 解决初始化时Cookies中不存在Key报错
  return wsCache.get(CACHE_KEY.POOL_NO) ? wsCache.get(CACHE_KEY.POOL_NO) : wsCache.get('poolNo')
}

export const setPoolNo = (poolNo: string) => {
  wsCache.set(CACHE_KEY.POOL_NO, poolNo)
}
